import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import useSWRMutation, { type SWRMutationConfiguration } from "swr/mutation";

type GenerateOgpImageInput = {
  marketId: string;
};

type FetchOgpImageResponse = {
  status: "success" | "error";
  error?: string;
};

const swrKey = "/prediction-market/generate-ogp-image";

const fetcher = async (url: string, { arg }: { arg: GenerateOgpImageInput }): Promise<FetchOgpImageResponse> => {
  const endpoint = `${url}/${arg.marketId}`;
  const response = await romanApi.get<FetchOgpImageResponse>(endpoint);
  return response;
};

export const useGenerateOgpImage = (
  swrOptions?: SWRMutationConfiguration<FetchOgpImageResponse, RomanApiError, string, GenerateOgpImageInput>,
) => {
  const { trigger, error, isMutating } = useSWRMutation<
    FetchOgpImageResponse,
    RomanApiError,
    string,
    GenerateOgpImageInput
  >(swrKey, fetcher, swrOptions);

  return {
    generateOgpImage: trigger,
    ogpImageError: error,
    isGeneratingOgpImage: isMutating,
  };
};
